import { ControlText, Spinner } from '@mint/ui';
import { AdminPanel } from '../admin-panel';
import { AdminWaitingPanelProps } from './admin-waiting-panel-props';
import React from 'react';

export const AdminWaitingPanel: React.FunctionComponent<
  AdminWaitingPanelProps
> = () => {
  return (
    <AdminPanel>
      <Spinner />
      <ControlText>Creating Page</ControlText>
    </AdminPanel>
  );
};
